import { Grid } from '@mui/material';

import { InitialCausalityFiltersProps } from './props';
import { usePqrInicialCausalityFilters } from './hook';

import LoadingButtonGeneral from '../../../../components/general/buttons/loadingButtonGeneral';
import AutocompleteField from '../../../../components/general/fields/autocompleteField';
import { Checkbox } from '../../../../components/general/fields/checkbox';
import FieldText from '../../../../components/general/fields/fieldText';

import { formatParams } from '../../../../../shared/utils/params';
import MultipleAutocompleteField from '../../../../components/general/fields/multipleAutocompleteField';

export const InitialCausalityFilters = ({
    onFilter,
    loading,
}: InitialCausalityFiltersProps) => {
    const {
        formik,
        products,
        motives,
        submotives1,
        submotives2,
        submotives3,
        submotives4,
        typeComplaint,
        typesPqr,
        technicalBranchs,
        unifiedProducts,
        typesMotives,
    } = usePqrInicialCausalityFilters(onFilter);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
        >
            <Grid
                container
                spacing={{ xs: 1.5, md: 1.5 }}
                columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            >
                <Grid item xs={12} sm={6} md={4}>
                    <MultipleAutocompleteField
                        data={formatParams(products)}
                        name="product"
                        label="Producto"
                        size="small"
                        touched={formik.touched.product}
                        errors={formik.errors.product}
                        value={formik.values.product}
                        onChangeValue={(selectedOptions: any[]) => {
                            const selectedNames = selectedOptions.map(
                                (opt) => opt.id
                            );
                            formik.setFieldValue('product', selectedNames);
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <MultipleAutocompleteField
                        data={typesPqr}
                        name="typePqr"
                        label="Tipo de Pqr"
                        size="small"
                        touched={formik.touched.typePqr}
                        errors={formik.errors.typePqr}
                        value={formik.values.typePqr}
                        onChangeValue={(selectedOptions: any[]) => {
                            const selectedNames = selectedOptions.map(
                                (opt) => opt.name
                            );
                            formik.setFieldValue('typePqr', selectedNames);
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <MultipleAutocompleteField
                        data={motives}
                        name="motive"
                        label="Motivo"
                        size="small"
                        touched={formik.touched.motive}
                        errors={formik.errors.motive}
                        value={formik.values.motive}
                        onChangeValue={(selectedOptions: any[]) => {
                            const selectedNames = selectedOptions.map(
                                (opt) => opt.id
                            );
                            formik.setFieldValue('motive', selectedNames);
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <AutocompleteField
                        data={formatParams(submotives1)}
                        label="Submotivo 1"
                        name="submotive1"
                        size="small"
                        onBlur={formik.handleBlur}
                        touched={formik.touched.submotive1}
                        errors={formik.errors.submotive1}
                        value={formik.values.submotive1}
                        onChangeValue={(value: any) =>
                            formik.setFieldValue('submotive1', value)
                        }
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <AutocompleteField
                        data={formatParams(submotives2)}
                        label="Submotivo 2"
                        name="submotive2"
                        size="small"
                        defineValue="value"
                        touched={formik.touched.submotive2}
                        errors={formik.errors.submotive2}
                        value={formik.values.submotive2 as string}
                        onChangeValue={(value: any) =>
                            formik.setFieldValue('submotive2', value)
                        }
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <AutocompleteField
                        data={formatParams(submotives3)}
                        label="Submotivo 3"
                        name="submotive3"
                        size="small"
                        defineValue="value"
                        touched={formik.touched.submotive3}
                        errors={formik.errors.submotive3}
                        value={formik.values.submotive3 as string}
                        onChangeValue={(value: any) =>
                            formik.setFieldValue('submotive3', value)
                        }
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <AutocompleteField
                        data={formatParams(submotives4)}
                        label="Submotivo 4"
                        name="submotive4"
                        size="small"
                        defineValue="value"
                        touched={formik.touched.submotive4}
                        errors={formik.errors.submotive4}
                        value={formik.values.submotive4 as string}
                        onChangeValue={(value: any) =>
                            formik.setFieldValue('submotive4', value)
                        }
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <Checkbox
                        label="Activo"
                        checked={Boolean(formik.values.active)}
                        onChange={() => {
                            formik.setFieldValue(
                                'active',
                                !formik.values.active
                            );
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Código motivo quejas sector SFC (Nuevo)"
                        name="sfcMotiveIdComplaint"
                        size="small"
                        touched={formik.touched.sfcMotiveIdComplaint}
                        errors={formik.errors.sfcMotiveIdComplaint}
                        value={formik.values.sfcMotiveIdComplaint}
                        onChange={formik.handleChange}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Nombre Motivo de Queja SFC"
                        name="motiveName"
                        size="small"
                        touched={formik.touched.motiveName}
                        errors={formik.errors.motiveName}
                        value={formik.values.motiveName}
                        onChange={formik.handleChange}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <AutocompleteField
                        data={formatParams(typeComplaint)}
                        label="Tipo de queja"
                        name="typeComplaint"
                        size="small"
                        onBlur={formik.handleBlur}
                        touched={formik.touched.typeComplaint}
                        errors={formik.errors.typeComplaint}
                        value={formik.values.typeComplaint}
                        onChangeValue={(value: any) =>
                            formik.setFieldValue('typeComplaint', value)
                        }
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <AutocompleteField
                        data={formatParams(technicalBranchs)}
                        label="Ramo técnico"
                        name="technicalBranch"
                        size="small"
                        onBlur={formik.handleBlur}
                        touched={formik.touched.technicalBranch}
                        errors={formik.errors.technicalBranch}
                        value={formik.values.technicalBranch}
                        onChangeValue={(value: any) =>
                            formik.setFieldValue('technicalBranch', value)
                        }
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <AutocompleteField
                        data={formatParams(unifiedProducts)}
                        label="Producto unificado"
                        name="unifiedProduct"
                        size="small"
                        onBlur={formik.handleBlur}
                        touched={formik.touched.unifiedProduct}
                        errors={formik.errors.unifiedProduct}
                        value={formik.values.unifiedProduct}
                        onChangeValue={(value: any) =>
                            formik.setFieldValue('unifiedProduct', value)
                        }
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <AutocompleteField
                        data={formatParams(typesMotives)}
                        label="Tipo de motivo"
                        name="typeMotive"
                        size="small"
                        onBlur={formik.handleBlur}
                        touched={formik.touched.typeMotive}
                        errors={formik.errors.typeMotive}
                        value={formik.values.typeMotive}
                        onChangeValue={(value: any) =>
                            formik.setFieldValue('typeMotive', value)
                        }
                    />
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Buscar"
                    sx={{ mr: 1 }}
                    onClick={formik.submitForm}
                />
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Limpiar"
                    variant="outlined"
                    onClick={formik.resetForm}
                />
            </Grid>
        </Grid>
    );
};
